export const SET_NG_WORDS = 'SET_NG_WORDS'
export const SET_UNREAD_FINEPLAY_APPROVE = 'SET_UNREAD_FINEPLAY_APPROVE'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const ADD_NGWORD = 'ADD_NGWORD'
export const UPDATE_NGWORD = 'UPDATE_NGWORD'
export const DELETE_NGWORD = 'DELETE_NGWORD'
export const SET_TOTAL_NOT_COMPLETE_SURVEY = 'SET_TOTAL_NOT_COMPLETE_SURVEY'
export const COMPLETE_SURVEY = 'COMPLETE_SURVEY'



// WEBPACK FOOTER //
// ./src/store/modules/masterData/mutation-types.js